
import * as actions from 'actions';
import infoMaker from 'reducersMakers/infoMaker';

export default infoMaker({
  showType: actions.INFO_SHOW,
  closeType: actions.INFO_CLOSE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/info/errors/reducer.js
 **/